module.exports = __webpack_public_path__ + "assets/orange-md-logo-e8c5d1.svg";